import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { toNumber } from 'lodash-es';
import { QuitPracticeDialogComponent } from '../quit-practice-dialog/quit-practice-dialog.component';
import { QUESTION_NOTAVAILABLE} from 'projects/selflearnv2-ui/src/app/constants/app.constants';
import { StartReviseComponent } from '../start-revise/start-revise.component';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserFeedbackPopupComponent } from '../../shared/components/user-feedback-popup/user-feedback-popup.component';
import { timeConvert } from 'projects/selflearnv2-ui/src/app/helpers/functions';

@Component({
  selector: 'app-revice-questions',
  templateUrl: './revice-questions.component.html',
  styleUrls: ['./revice-questions.component.css']
})
export class ReviceQuestionsComponent implements OnInit {

  defaultQuestion: number = 0;
  disablePrev: boolean = true;
  disableNext: boolean = false;
  public flagData: any = {
    showCorrectChoice: false,
    isSolution: false,
    showSolutionBtn: false,
    isDisabled: false,
    isSelected: false,
    enableNextBtn: false,
    isPractice: true,
    isFeedback: false,
    isQuestionSubmit: false,
    isQuit: true,
    isQuestionSkipped: false,
    enableSkipBtn: false,
    localBookmarkFlag: false
  }
  public selectedData: any = {
    index: null,
    selectedQuestionData: null,
    selectedQuestionChoiceData: null,
    selectedOption: null,
    selectedOptionNumber: 0,
    reportErrorArray: []
  }
  public deviceWidth:any;
  public type: 'practice' | 'feedback' = 'practice';
  public topicAndSubTopic: any = null;
  public questionsData: Array<any> = [];
  public revCardNo: any = 0;
  public revCardData: any = {};
  public progresses: any = [];
  progIndex: number = -1;
  questionSubmitMessage: any;
  timeConvert = timeConvert
  // start of  Different question types
  matrixColumns: any = [
    ['P', 'Q', 'R', 'S'],
    ['A', 'B', 'C', 'D', 'E']
  ]
  matrixReponses: any = {};
  selectedAnswer: any = [];
  numPadDigits1To9: any = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
  selectedNPadBtnText = '';
  selectedMultiAnswer: any = {};
  // end of Different question types
  public initialLoading = true;
  attemptedQuestion:boolean = false;
  @ViewChild("questioncontainer") questioncontainer: ElementRef;
  currentTime: number = new Date().getTime();
  questionList:any = [];
  questionIds:any = [];
  progress = -1;
  timeSpent: any =0;
  interval: any;
  isCurrentQuestionSubmitted:boolean = false;
  userLikeStatus: boolean = false;
  userDislikeStatus: boolean = false;
  constructor(public dialog: MatDialog, 
    public spinner:NgxSpinnerService, public selfLearnService: SelfLearnService, public router: Router) { }

  ngOnInit(): void {
    if(localStorage.getItem('isItFromVideoSolution')!='true'){
      
      this.getFlashcardsAndQuestions();
      this.showStartRevisionPopup();
    }else{
      this.questionsData =JSON.parse(localStorage.getItem('revisequestions'));
      this.questionIds = JSON.parse(localStorage.getItem('reviseeQuestionIds'));
      this.progress = JSON.parse(localStorage.getItem('reviseQuestionsProgress'));
      this.revCardNo = Number(localStorage.getItem('reviseQuestionsNumber'));
      this.revCardNo = this.revCardNo-1;
      this.progress = this.progress-1;
      this.nextQuestion();
      this.showSolution();
      localStorage.removeItem('isItFromVideoSolution');
    }
   
 
    this.startTimer();
  }

  showStartRevisionPopup(){
    const config: MatDialogConfig = {
      width: '768px',
      panelClass: ['test-instruction-modal'],
    };
    this.dialog.open(StartReviseComponent, config);
  }

  quitRevision(){
    const config: MatDialogConfig = {
      // width: '620px',
      panelClass: ['qiut-practice-modal', 'mweb-stiky-bottom'],
      data: {
        topicName: this.selfLearnService.getTopicName(),
        type: "Quit Revision",
      }
    };
    this.dialog.open(QuitPracticeDialogComponent, config);
  }

  getFlashcardsAndQuestions(){
    this.spinner.show();
    this.selfLearnService.getFlashcardsAndQuestions().subscribe((resp:any) => {
      if(resp?.data){
        this.questionIds = resp?.data?.questionIds;
        this.getReviseQuestions();
      }
      this.spinner.hide();
    })
  }

  getReviseQuestions(){
    const payload = this.constructJsonForQuestions();
    this.selfLearnService.getReviseQuestions(payload).subscribe((resp:any) => {
      if(resp?.data){
        this.questionsData = resp.data || [];
        //this.questionsData = this.questionsData.filter((item:any) => item.question_type == "single correct mcq"); 
        this.getTopicSummaryAndQuestions();
      
      }
    })
  }
  getTopicSummaryAndQuestions(){
    this.selfLearnService.getTopicSummaryAndQuestions().subscribe((resp:any) => {
      this.questionsData = this.questionsData.map((item) => {
        const found = resp?.data?.questions.find((element:any) => item.question_id == element.questionId);
        if(found){
          item['completed']= found.isCompleted ? found.isCompleted : false;
          item['isBookmarked'] = found.isBookmarked ? found.isBookmarked : false;
        }else{
          item['completed']= false
          item['isBookmarked'] = false
        }
        return {...item}
      });
      this.getLikeandDislikeStatusForQuestions()
   
    })
  }
  getLikeandDislikeStatusForQuestions(){
    this.selfLearnService.getLikeandDislikeStatusForQuestions( this.questionIds).subscribe((res:any) => {
      this.questionsData = this.questionsData.map((item) => {
        const found = res?.find((element:any) => item.question_id == element.questionId);
        if(found){
          item['isLiked'] = found.isLiked ? found.isLiked : false;
          item['isDisLiked'] = found.isDisliked ?  found.isDisliked : false;
          item['likedCount'] = found.likedCount ? found.likedCount : false;

        }else{

          item['isLiked'] = false
          item['isDisLiked'] = false
          item['likedCount'] = false
        }
        return {...item}
      });
      this.assignInitialValuesToQuestionsData();
      
    })
  }

  constructJsonForQuestions(){
    return {"ids":
      this.questionIds
    };
  }

  setRevCardNumber(){
    const fcq = this.getFCQsFromLocalStorage()
    this.revCardNo = fcq.length;
    this.revCardData = fcq[fcq.length - 1];
  }

  // submitAndGetPracticeQuestionsV2(isFromInit?){
  //   let payload = this.constructPayLoadForsubmitAndGetPracticeQuestionsV2();
  //   this.selfLearnService.submitAndGetPracticeQuestionsV2(payload).subscribe((response) => {
  //     if (response.data.length != 0) {
  //       this.questionSubmitMessage = response.message
  //       this.questionsData = response.data || [];
  //       this.assignInitialValuesToQuestionsData()
  //       this.setLevel()
  //       this.startPractice(isFromInit)
  //       this.checkIsAttemptedQuestion()
  //       this.getCurrentQuestionIndexOfLevel()
  //     } else {
  //       this.questionsData = response.data || [];
  //       this.initialLoading = false
  //     }
  //     this.initialLoading = false;
  //   })
  // }

  // constructPayLoadForsubmitAndGetPracticeQuestionsV2(){
  //   return {
  //     chapterid: Number(this.selfLearnService.getChapterId()),
  //     examid: Number(this.selfLearnService.getCmsExamID()[0]),
  //     gradeid: Number(this.selfLearnService.getGradeId()),
  //     subjectid: Number(this.selfLearnService.getSubjectId()),
  //     topicid: Number(this.selfLearnService.getTopicId()),
  //     topicName: this.selfLearnService.getTopicName(),
  //     chapterName: this.selfLearnService.getChapterName(),
  //     timetakeninsecs: 0,
  //     level: Number(this.selfLearnService.getPracticeLevel()) == 0 ? 1 : Number(this.selfLearnService.getPracticeLevel()),
  //   }
  // }

  // submitAndGetPracticeQuestionsV2Next(quesdata, newobj){
  //   let payload = this.constructPayLoadForsubmitAndGetPracticeQuestionsV2Next(quesdata, newobj);
  //   this.selfLearnService
  //     .submitAndGetPracticeQuestionsV2(payload)
  //     .subscribe(
  //       (response) => {
  //         if (response.data.length != 0) {
  //           this.questionSubmitMessage = response.message
  //           this.questionsData = response.data || [];
  //           this.assignInitialValuesToQuestionsData();
  //         }
  //         this.getVideoSolution()
  //       },
  //       (error: any) => {
  //       }
  //     );
  // }

  // constructPayLoadForsubmitAndGetPracticeQuestionsV2Next(quesdata, newobj){
  //   return {
  //     chapterid: this.selfLearnService.getChapterId(),
  //     examid: this.selfLearnService.getCmsExamID()[0],
  //     gradeid: this.selfLearnService.getGradeId(),
  //     subjectid: this.selfLearnService.getSubjectId(),
  //     topicid: this.selfLearnService.getTopicId(),
  //     topicName: this.selfLearnService.getTopicName(),
  //     chapterName: this.selfLearnService.getChapterName(),
  //     difficultyLevel: quesdata.difficulty_level,
  //     isCorrectAnswer: newobj.is_correct_answer,
  //     isskipped: newobj.is_skipped,
  //     level: quesdata.level,
  //     questionid: quesdata.question_id,
  //     subtopicid: quesdata.subtopic_id,
  //     timetakeninsecs:  Math.abs((new Date().getTime() -quesdata.new_obj.timetakeninsecs)/1000).toFixed() || 0,
  //     userAnswers: newobj.userAnswers,
  //   }
  // }

  getCurrentQuestionIndexOfLevel(){
    const fcq = this.getFCQsFromLocalStorage()
    if(fcq.length > 1){
      this.previousQuestion()
      setTimeout(() => {
        this.nextQuestion()
      }, 50);}
  }

  assignInitialValuesToQuestionsData(): any {
    let arr:any = [];
    let new_obj:any = {
      is_answer_selected: false,
      is_question_submitted: false,
      is_previous: false,
      is_skipped: false,
      is_bookmarked: false,
      is_correct_answer: false,
      userAnswers: null,
      timetakeninsecs:new Date().getTime(),
      isLiked:false,
      isDisLiked:false,
    }
    this.questionsData.forEach(e => {
      e.new_obj = new_obj
      arr.push(e);
    });
    localStorage.setItem('revisequestions', JSON.stringify(arr))
    this.nextQuestion()
  }

  getFCQsFromLocalStorage(): any {
    return JSON.parse(localStorage.getItem('revisequestions')) || []
  }

  setFCQsFromLocalStorage(arr) {
    localStorage.setItem('revisequestions', JSON.stringify(arr))
  }

  showSolution(): any {
    this.flagData.isSolution = true
    this.getVideoSolution();
  }

  showSolutionMobile(): any {
    this.flagData.isSolution = !this.flagData.isSolution
  }
 
  onSelectedAnswer(selectedQuestionData:any, selectedQuestionChoiceData:any): any {
    this.flagData.isQuestionSubmit = true
    this.selectedData.selectedQuestionData = selectedQuestionData
    this.selectedData.selectedQuestionChoiceData = selectedQuestionChoiceData
  }

  saveIndex(i: any) {
    this.selectedData.index = i;
  }

  isCorrect(qc:any, option: number): boolean {
    return option === toNumber(this.revCardData.question.correct_answer);
  }

  isIncorrect(qc:any, option: number): boolean {
    return option !== toNumber(this.revCardData.question.correct_answer) && this.selectedData.selectedOptionNumber == option;
  }

  radioChange(answer: number, selectedIndex:any) {
    this.selectedData.selectedOption = answer;
    this.selectedData.selectedOptionNumber = selectedIndex
    this.flagData.isSelected = true
    this.saveIndex(selectedIndex-1);
    // this.flagData.isDisabled = true;
  }

  nextQuestion() {
    this.flagData.isDisabled = false
    this.selectedData.index = null
    this.selectedMultiAnswer = {};
    this.selectedNPadBtnText = "";
    this.selectedAnswer[0] = ""
    if(!this.revCardData.is_skipped)
    this.updateTimeSpentForQuestion();
     this.currentTime = new Date().getTime()
    if (this.revCardNo <= this.questionsData.length - 1) {
      this.revCardNo += 1;
      let fcq = this.getFCQsFromLocalStorage()
      this.revCardData = fcq[this.revCardNo - 1];
      this.selectedAnswer[0] =   this.revCardData.userAnswers;
      //this.questioncontainer.nativeElement.scrollTop = 0;
      this.updateCurrentQuestionTimer();
    }
    
    this.progress++;
    this.checkIsAttemptedQuestion()
     //this.getVideoSolution()
  }

  previousQuestion() {
    this.updateTimeSpentForQuestion();
    this.currentTime = new Date().getTime()
    this.flagData.isDisabled = false
    this.selectedData.index = null
    this.revCardNo -= 1;
    this.flagData.enableSkipBtn = false
    let fcq = this.getFCQsFromLocalStorage()
    this.revCardData = fcq[this.revCardNo - 1];
    this.selectedAnswer[0] =   this.revCardData.userAnswers;
    this.selectedMultiAnswer = {};
   
    
    this.progress--;
    for (let i = 0; i < fcq.length; i++) {
      const e = fcq[i];
      e.timetakenInSecs = Math.abs( (this.currentTime - fcq[i]?.new_obj?.timetakeninsecs)/1000).toFixed(0) || 0;
    }
    this.checkIsAttemptedQuestion()
    setTimeout(() => {
    this.questioncontainer.nativeElement.scrollTop = 0;
    }, 50);
   this.updateCurrentQuestionTimer();
    //this.isFromInit()
  }

  checkIsAttemptedQuestion(): any {
    let fcq = this.getFCQsFromLocalStorage()
    if (fcq[this.revCardNo - 1].userAnswers != null) {
      this.undoConditions()
    } else {
      this.resetConditions()
    }
  }

  resetConditions(): void {
    this.selectedData.index = null
    this.flagData.showCorrectChoice = false
    this.flagData.isSolution = false
    this.flagData.showSolutionBtn = false
    this.flagData.isQuestionSubmit = false
    this.flagData.isSelected = false;
    this.flagData.enableNextBtn = false;
    this.selectedData.selectedOption = null;
  }

  undoConditions(): void {
    const data = JSON.parse(localStorage.getItem('revisequestions'))
    this.flagData.showCorrectChoice = true
    this.flagData.isSolution = false
    this.flagData.showSolutionBtn = true
    this.flagData.isQuestionSubmit = true
    this.flagData.isSelected = true;
    this.flagData.enableNextBtn = true;
    this.selectedData.selectedOptionNumber = Number(data[this.revCardNo - 1].userAnswers)
    this.isIncorrect(this.selectedData.selectedOptionNumber, toNumber((data[this.revCardNo - 1].question.correct_answer)))
    this.flagData.isDisabled = true
  }


  submitEntireLearningFlashDeck(): any {
    this.router.navigate([`selfLearn-V2/revise-completion`]);
  }

  submitSelectedQuestion(): any {

     let new_obj:any;
    // this.is_question_submitted = true
    if(this.revCardData.question_type =="multiple correct mcq"){
      let returnMC = false;
      let optionsChosen : any = []; 
      const keys = Object.keys(this.selectedMultiAnswer); 
      let correctArr = this.revCardData.question.correct_answer;
      let correctCheck = false;
      for (let i = 0, l = keys.length; i < l; i++) {  
        if (this.selectedMultiAnswer[keys[i]] === true) {
          optionsChosen.push(keys[i]); 
          console.log(correctArr.includes(keys[i]));
            if(!correctArr.includes(Number(keys[i])) && !returnMC){
              correctCheck = true; 
            }
        }
      }  
      this.revCardData.userAnswers = optionsChosen.toString();
      const correctOption = this.revCardData.question.correct_answer
      const  iscorrectanswer = (!correctCheck && (correctArr.length ==optionsChosen.length)) ? true : false;
       new_obj = {
        is_correct_answer: iscorrectanswer,
        is_bookmarked: this.revCardData.isBookmarked,
        is_skipped: false,
        userAnswers: optionsChosen.toString()
      }
     }else if(this.revCardData.question_type =='integer type question' || this.revCardData.question_type =='numerical value question'){
      const correctOption = toNumber((this.revCardData.question.correct_answer))
      const  iscorrectanswer = (Number(this.selectedData.selectedQuestionData[0]) === correctOption) ? true : false
       new_obj = {
        is_correct_answer: iscorrectanswer,
        is_bookmarked: this.revCardData.isBookmarked,
        is_skipped: false,
        userAnswers: Number(this.selectedData.selectedQuestionData[0])
      }
      }else {
        const correctOption = toNumber((this.revCardData.question.correct_answer))
        const  iscorrectanswer = (this.selectedData.selectedOptionNumber === correctOption) ? true : false
         new_obj = {
          is_correct_answer: iscorrectanswer,
          is_bookmarked: this.revCardData.isBookmarked,
          is_skipped: false,
          userAnswers: this.selectedData.index + 1
        }

      }
      this.attemptedQuestion = true;
      this.flagData.isQuestionSkipped = false
      this.flagData.showCorrectChoice = true
      this.flagData.showSolutionBtn = true
      this.flagData.isDisabled = true;
      this.flagData.isQuestionSubmit = false
      this.flagData.enableNextBtn = true 
       this.isCurrentQuestionSubmitted = true;

    this.revCardData.new_obj.userAnswers = new_obj.userAnswers;
    const fcq = this.getFCQsFromLocalStorage()
    fcq[this.revCardNo - 1]['userAnswers'] = new_obj.userAnswers;
    this.setFCQsFromLocalStorage(fcq);
    this.updateTopicSummaryQuestion(fcq[this.revCardNo - 1], new_obj)
    // if (this.revCardNo == this.questionsData.length) {
    //   this.submitEntireLearningFlashDeck();
    // }
    this.updateUserAnswerInLocal(new_obj);
  }
  updateUserAnswerInLocal(newObj:any){
    this.questionsData.map((item:any) =>{
      if(this.revCardData.question_id == item.question_id){
        item.userAnswers = newObj.userAnswers;
      }
    })
  }


  updateTopicSummaryQuestion(quesdata:any, newobj:any){
    let payload = this.constructPayLoadForUpdateTopicSummaryQuestion(quesdata, newobj);
    this.selfLearnService
      .updateTopicSummaryQuestion(payload)
      .subscribe(
        (response) => {
          clearInterval(this.interval);
          this.startTimer();

        });
  }

  constructPayLoadForUpdateTopicSummaryQuestion(quesdata:any, newobj:any){
    const payload = {
      chapterId: Number(this.selfLearnService.getChapterId()),
      examId: Number(this.selfLearnService.getCmsExamID()),
      gradeId: Number(this.selfLearnService.getGradeId()),
      subjectId: Number(this.selfLearnService.getSubjectId()),
      topicId: Number(this.selfLearnService.getTopicId()),
      topicName: this.selfLearnService.getTopicName(),
      chapterName: this.selfLearnService.getChapterName(),
      isCompleted: true,
      isBookmarked: false,
      flashcardquestions: [
        {
          subtopicId: quesdata.toc_mapping.sub_topic_id[0],
          questionId: quesdata.question_id,
          difficultyLevel: quesdata.difficulty_level,
          isCorrectAnswer: newobj.is_correct_answer,
          timeTakenInSecs: this.timeSpent,
          isSkipped: newobj.is_skipped,
          isBookmarked: quesdata.isBookmarked,
          isAttempted: !newobj.is_skipped,
          userAnswers: newobj.userAnswers,
          questionType: quesdata.question_type,
          isLiked:quesdata.isLiked,
          isDisLiked:quesdata.isDisLiked,

        }
      ]
    }
    return payload;
  }
  constructPayLoadForLikeDisLikeandBookmark(){
    console.log(this.revCardData)
    const payload = {
      chapterId: Number(this.selfLearnService.getChapterId()),
      examId: Number(this.selfLearnService.getCmsExamID()),
      gradeId: Number(this.selfLearnService.getGradeId()),
      subjectId: Number(this.selfLearnService.getSubjectId()),
      topicId: Number(this.selfLearnService.getTopicId()),
      topicName: this.selfLearnService.getTopicName(),
      chapterName: this.selfLearnService.getChapterName(),
      isCompleted: true,
      isBookmarked: false,
      flashcardquestions: [
        {
          subtopicId: this.revCardData.toc_mapping.sub_topic_id[0],
          questionId: this.revCardData.question_id,
          difficultyLevel: this.revCardData.difficulty_level,
          isBookmarked: this.revCardData.isBookmarked,
          questionType: this.revCardData.question_type,
          isLiked:this.revCardData.isLiked,
          isDisLiked:this.revCardData.isDisLiked,
          isCorrectAnswer: this.revCardData.new_obj.is_correct_answer,
          timeTakenInSecs: this.timeSpent,
          isSkipped: this.revCardData.new_obj.is_skipped,
          isAttempted: this.revCardData.new_obj.is_skipped,
          userAnswers: this.revCardData.new_obj.userAnswers,
        }
      ]
    }
    this.selfLearnService
      .updateTopicSummaryQuestion(payload)
      .subscribe(
        (response) => {

        });
  }

  checkPracticeQuestionCompletedOrNot(): any {
    let arr:any = []
    this.progresses.forEach((p:any) => {
      if (p == 100) {
        arr.push(p)
      }
    });
    if (arr.filter((o1:any) => this.progresses.some((o2:any) => o1 === o2))) {
      return true
    }
  }

  getVideoSolution() {
    let findQuestionIndex = this.questionsData.findIndex(v => v?.question_id == this.revCardData?.question_id)
    if (this.questionsData[findQuestionIndex].question.video_solution_id) {
      if(this.questionsData[findQuestionIndex].question.video_solution_id!=""){
      this.questionsData[findQuestionIndex].question.video_solution_data = true;
      console.log('this.revCardData?.question: ', this.revCardData?.question);
      let params = {
        examId:this.revCardData.exam_id,
        gradeId: this.selfLearnService.getGradeId(),
        module:'practice'       
      } 
      this.selfLearnService.getVideoCms(this.revCardData?.question?.video_solution_id).subscribe((resp: any) => {
        if(resp?.video){
          resp.video.videoUrl =  resp.video.videoURL;
          resp.video.videoName = resp?.video?.title
        }
        this.questionsData[findQuestionIndex].question.video_solution_data = { ...resp?.video }
        this.questionsData[findQuestionIndex].question.duration = this.timeConvert(resp?.video?.duration||0) 
      if(this.revCardData?.question?.video_solution_id ==resp?.video?.videoId ){
        this.revCardData.question.video_solution_data={ ...resp?.video }
        this.revCardData.question.video_solution_data.duration = this.timeConvert(resp?.video?.duration||0)
      }
       // this.assignInitialValuesToQuestionsData()
      })
    }
  }
  }

  skipQuestion() {
    this.flagData.isQuestionSkipped = true
    let fcq = this.getFCQsFromLocalStorage()
    this.revCardData = fcq[this.revCardNo - 1];
    this.revCardData.isBookmarked = this.revCardData.isBookmarked
    this.updateTimeSpentForQuestion();
      this.skipSelectedQuestion(this.revCardData)
    this.checkIsAttemptedQuestion()
    if (this.revCardNo == this.questionsData.length) {
      this.flagData.enableSkipBtn = false
      this.flagData.isDisabled = true
      this.selectedData.index = null
      this.submitEntireLearningFlashDeck();
    }
    setTimeout(() => {
      if (this.revCardNo == this.questionsData.length && this.questionSubmitMessage == QUESTION_NOTAVAILABLE) {
        this.flagData.enableSkipBtn = true
      } else {
          this.nextQuestion()
      }
    }, 1000);
  }
  updateTimeSpentForQuestion(){
    this.questionsData.map((item:any) =>{
      if(this.revCardData.question_id == item.question_id){
        item.timetakenInSecs = this.timeSpent;
      }
    })
  }

  skipSelectedQuestion(skippedQuestion:any): any {
    this.flagData.localBookmarkFlag = false
    this.flagData.showCorrectChoice = false
    this.flagData.showSolutionBtn = false
    this.flagData.isQuestionSubmit = false
    this.flagData.enableNextBtn = true
  }

  // Question type numeric
  padBtnClick(e: any, btnVal: any) {
    e.preventDefault();
    e.stopPropagation();
    let newAns: any;
    const currentAns:any = this.selectedAnswer || "";
    this.selectedNPadBtnText = btnVal;
    if (btnVal == "clear") {
      this.selectedNPadBtnText = "";
      this.flagData.isSelected = false;
    }else if(btnVal == "-"){
      if(this.selectedAnswer[0]==null || this.selectedAnswer[0]==undefined){
        newAns = btnVal;
      }else{
        newAns = this.selectedAnswer[0];
      }
    }
     else {
      this.flagData.isSelected = true
      newAns = this.selectedAnswer[0] ? this.selectedAnswer[0]+btnVal : btnVal;
    }
    this.selectedAnswer = [newAns]
    this.flagData.isQuestionSubmit = true
      this.selectedData.selectedQuestionData =this.selectedAnswer
      this.selectedData.selectedQuestionChoiceData = this.selectedAnswer
  }

  getTotalQuestionCountForAllLevels(){
    const subtopicCount = JSON.parse(localStorage.getItem('subtopicCount'));
    return ((subtopicCount*5))
  }

  isDoneBtnDisabled(){
    const button:any = document.getElementById('doneBtn');
    return (button) ? button['disabled'] : true;
  }
  fmtMSS(s:any){   
    return(s-(s%= 60))/60 +(9 < s ? ':':':0') + s ;      
  }
  startTimer() {
    this.interval = setInterval(() => {
      if(!this.isCurrentQuestionSubmitted)
          this.timeSpent++;
    },1000)
  }
  updateCurrentQuestionTimer(){
    console.log(this.revCardData)
    let tempQuestionData:any = this.questionsData.filter((item:any) => this.revCardData.question_id == item.question_id)
    if(this.revCardData.question_id == tempQuestionData[0].question_id){
      clearInterval(this.interval)
      this.timeSpent = tempQuestionData[0].timetakenInSecs ? tempQuestionData[0].timetakenInSecs: 0;
      this.isCurrentQuestionSubmitted = tempQuestionData[0].userAnswers ? tempQuestionData[0].userAnswers : 0;
      this.startTimer();
    }

  }
  redirectToVideoPage(){
    console.log(this.revCardData?.question?.video_solution_id);
    localStorage.setItem('reviseeQuestionIds', JSON.stringify(this.questionIds));
    localStorage.setItem('reviseQuestionsProgress',JSON.stringify(this.progress));
    localStorage.setItem('reviseQuestionsNumber',JSON.stringify(this.revCardNo));
    localStorage.removeItem("selfLearnSelectedPlayList");
    localStorage.removeItem("selfLearnPreviousPage", );
    localStorage.removeItem('selfLearnSelectedVideoId')
    localStorage.setItem('selectedTopicName',this.selfLearnService.getTopicName())
    localStorage.setItem("selfLearnPreviousPage", 'selfLearn-V2/revise-questions');
    localStorage.setItem('selfLearnSelectedVideoId', this.revCardData?.question?.video_solution_id)
    this.router.navigateByUrl('selfLearn-V2/videoplayback');
  }
   // Question type multiple answer type
   onMultiAnswerSelect(index:any, event:any){
    console.log(index,'index')
    console.log(event.target.value,'event');
    this.selectedMultiAnswer[index+1] = true;
    this.flagData.isQuestionSubmit = true
    this.flagData.isSelected = true;

   }
   onMultiAnswerDeSelect(index:any, event:any){
    this.selectedMultiAnswer[index+1] = false;
    this.selectedData.selectedQuestionData.pop(''+(index+1))
    this.selectedData.selectedQuestionChoiceData.pop(''+(index+1))
    console.log( this.selectedMultiAnswer);
   }
   checkMultiSelectAnswer(index:any){ 
    let correctans  = this.revCardData.question.correct_answer;
    let mres = this.revCardData.new_obj.userAnswers?.split(",");
    if(mres?.includes(String(index+1))){
      if(correctans.includes(index+1)){
        return 'correctAns';
      }else{
        return 'wrongAns';
      }  
    }else{
      if(correctans.includes(index+1)){
        return 'correctAns';
      }else{
        return '';
      }
    }
  }
  checkMultiChecked(index:any){ 
    let mres = this.revCardData.userAnswers.toString();
    //mres = mres?.map((arr:any) => arr.trim());
    if(mres?.includes(index+1)){ 
        return true;
      }else{
        return false;
      }  
  }

  openUserFeedbackDialog() {
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {

      data: {assetType:"questionReport",
      assetId: this.revCardData.question_id}
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  userLike(){
    this.revCardData.isLiked = true;
    this.revCardData.isDisLiked =  false;
    let tempRevData = this.getFCQsFromLocalStorage();
    console.log(tempRevData)
     tempRevData.map((question:any) => {
   if(question.question_id ==  this.revCardData.question_id){  
    question.isLiked = this.revCardData.isLiked;
    question.isDisLiked =  this.revCardData.isDisLiked;
    return question;
   }})
 
     localStorage.setItem('revisequestions', JSON.stringify(tempRevData))
    this.constructPayLoadForLikeDisLikeandBookmark();
    this.userLikeStatus = !this.userLikeStatus;
  }

  userDislike(){
    this.userDislikeStatus = true;
    this.revCardData.isDisLiked = true;
    this.revCardData.isLiked = false
    let tempRevData = this.getFCQsFromLocalStorage();
    console.log(tempRevData)
     tempRevData.map((question:any) => {
   if(question.question_id ==  this.revCardData.question_id){  
    question.isLiked = this.revCardData.isLiked;
    question.isDisLiked =  this.revCardData.isDisLiked;
    return question;
   }})
 
     localStorage.setItem('revisequestions', JSON.stringify(tempRevData))
    this.constructPayLoadForLikeDisLikeandBookmark();
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {
      data: {assetType:"questionFeedback",
      assetId: this.revCardData.question_id
     }
    });
    
    dialogRef.afterClosed().subscribe(() => {
    });
  }
  bookmarkQuestion(){
    this.revCardData.isBookmarked = !this.revCardData.isBookmarked;
    this.constructPayLoadForLikeDisLikeandBookmark()
  }
}
